// Utility to play a notification bell sound using Web Audio API (iOS-like chime)
export const playNotificationSound = () => {
  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();

    const playTone = (freq: number, startTime: number, duration: number, gain: number) => {
      const osc = ctx.createOscillator();
      const gainNode = ctx.createGain();

      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, startTime);

      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(gain, startTime + 0.01);
      gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + duration);

      osc.connect(gainNode);
      gainNode.connect(ctx.destination);

      osc.start(startTime);
      osc.stop(startTime + duration);
    };

    const now = ctx.currentTime;
    // Three-tone chime (similar to iOS tri-tone)
    playTone(880, now, 0.15, 0.3);        // A5
    playTone(1108.73, now + 0.12, 0.15, 0.25); // C#6
    playTone(1318.51, now + 0.24, 0.3, 0.2);   // E6

    // Clean up after sound finishes
    setTimeout(() => ctx.close(), 1000);
  } catch (e) {
    console.warn("Could not play notification sound:", e);
  }
};
